module.exports = __webpack_public_path__ + "static/media/custom_design_solutions.bfe8b2c9.svg";